import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import posthog from 'posthog-js';
import App from './App';

// Initialize PostHog
posthog.init(
  'phc_LC0j780Jg37TYjVl42d98PYzJwLVLLdrvH5stX15av2',
  {
    api_host: 'https://eu.i.posthog.com',
    loaded: (posthog) => {
      if (import.meta.env.DEV) {
        // In development, log to console instead of sending events
        posthog.opt_out_capturing();
      }
    },
    capture_pageview: true,
    capture_pageleave: true,
  }
);


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
        <App />
      </SnackbarProvider>
    </BrowserRouter>
  </StrictMode>
);